<template lang="html">
    <div class="surroundingsContainer" id="pullrefresh">
    	<div class="listContainer">
			<div class="container" v-for="(item,index) in surroundingsArray">
				<div class="imgContainer">
					<img v-bind:src="imgSrc+item.PIC_PATH" />
					<!-- <img src="../../assets/img/index-exchange.png" /> -->
				</div>
				<div class="textContainer">
					<div class="text-title">{{item.TITLE}}</div>
					<div class="text-content">{{item.ABSTRACT}}</div>
					<router-link :to="{ name:'surroundingsDetail',params: { infoId: item.INFO_ID},query: { typeCode: item.TYPE_CODE }}">
						<div class="exBtn" v-on:click="toDetailInfo(index)">查看详情</div>
					</router-link>
				</div>
			</div>
		</div>
		<div class="loading" v-show="loadingIndex"><img src="../../assets/img/loading.gif" /><span>{{loadingTxt}}</span></div>
    </div>
</template>
<script>
	import {commonPicUrl} from '../../common/url.js'
	import Server from '../../server/server.js'
	import $ from 'jquery'
	export default {
	  	name: 'surroundingsContainer',
	  	data(){
		  	return{
		  		imgSrc:commonPicUrl,
		  		surroundingsArray:[],
		  		startIndex:0,
		  		endIndex:5,
		  		pageLength:6,
		  		typeCode:'9903002',
		  		page:0,
		  		loadingIndex:true,   //滚动是否加载数据
		  		timer:null,
		  		loadingTxt:'正在加载中 ...',
		  		loadingTimer:null,
		  	}
	  	},
	  	methods:{
	  		//专属周边数据
	  		getInfo:function(page){
	  			let startIndex = page+this.startIndex;
	  			let endIndex = page+this.endIndex;
	  			let array=[];
	  			Server.listInfo(startIndex,endIndex,this.typeCode).then((result)=>{
		  			if(result.code == '0'){
		  				console.log(this.loadingIndex);
		  				if(result.msg.infos.length>0){
		  					this.surroundingsArray = this.surroundingsArray.concat(result.msg.infos);
		  					if(result.msg.infos.length < this.pageLength){
		  						this.loadingTxt = '没有更多内容了';
		  						let that = this;
			  					clearTimeout(that.loadingTimer);
				        		that.loadingTimer=setTimeout(function () {
					                that.loadingIndex = false;	
					                console.log(that.loadingIndex);
					           	},50);
		  					}
		  				}else{
		  					let that = this;
		  					clearTimeout(that.loadingTimer);
			        		that.loadingTimer=setTimeout(function () {
				                that.loadingIndex = !that.loadingIndex;	
				           	},50);
		  					
		  				}	
		  			}
		  		})
	  		},
	  		//跳转资讯详情
	  		toDetailInfo:function(index){
	  			let sequence = parseInt(index);
	  			localStorage.setItem('surroundingsIndex',sequence);
	  			console.log(localStorage.getItem('surroundingsIndex'));
	  		}
	  	},
	  	created(){
	  		//专属周边数据,先获取专属周边栏目1的两篇数据，然后再获取专属周边栏目2的数据
	  		Server.listInfo(0,1,'9903001').then((result)=>{
	  			if(result.code == '0'){
	  				// console.log(result.msg.infos.length);
	  				this.surroundingsArray = this.surroundingsArray.concat(result.msg.infos);
	  				this.getInfo(this.page);
	  			}
	  		})
	  		
	  	},
	  	mounted(){
	  		let that = this;
	  		$('.surroundingsContainer').scroll(function(){
		        var contentHeight = $('.surroundingsContainer').height(),
		            contentScroll = $('.surroundingsContainer').scrollTop(),
		            contentScrollHeight = document.getElementById("pullrefresh").scrollHeight;
		        if(that.loadingIndex){
		        	if(contentHeight+contentScroll+20>=contentScrollHeight){
		        		clearTimeout(that.timer);
		        		that.timer=setTimeout(function () {
			                that.page = that.page +that.pageLength;
			            	that.getInfo(that.page);
			           },500);
			        }
		        }
		        
		    })
	  	}

	}
</script>
<style lang="less" scoped>
	.surroundingsContainer{
		margin-top:30px;
		padding:0px 40px;
		width:100%;
		height:800px;
		overflow:scroll;
		.container{
			width:100%;
			margin-bottom:20px;
			display:inline-block;
			.imgContainer{
				float:left;
				width:30%;
				img{
					max-height:200px;
					width:100%;
				}
			}
			.textContainer{
				float:right;
				width:70%;
				padding-left:20px;
				text-align:left;
				.text-title{
					font-size:28px;
					color:#333333;
					letter-spacing:0;
					line-height:40px;
					height:40px;
					text-overflow:ellipsis;
					overflow: hidden;
			    	display: -webkit-box;
	    			-webkit-line-clamp: 1;
	    			-webkit-box-orient: vertical;
	    			word-break:break-all;
	    			-webkit-box-orient: vertical;
	    			font-weight:bold;
				}
				.text-content{
					margin-top:5px;
					font-size:24px;
					color:#666666;
					letter-spacing:0.08px;
					line-height:40px;
					height:80px;
					overflow: hidden;
			    	display: -webkit-box;
	    			-webkit-line-clamp: 2;
	    			word-break:break-all;
	    			-webkit-box-orient: vertical;
				}
				.exBtn{
					background-image:linear-gradient(90deg, #f1e3bb 0%, #e0c385 100%);
					border-radius:10px;
					width:160px;
					height:70px;
					float:right;
					margin-top:5px;
					line-height:70px;
					text-align:center;
					color:#fff;
					font-size:28px;
					letter-spacing:1px;
				}
			}
		}
		.loading{
			width:100%;
			height:40px;
			text-align:center;
			line-height:40px;
			img{
				vertical-align:middle;
				width:40px;
			}
			span{
				padding-left:10px;
				font-size:26px;
				color:#666666;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/surroundings/surroundingsContainer.vue